// Web Audio API synthesized phone ringtone and audio unlocker.
// Works 100% offline with zero external network requests and no CDN dependency.

let audioCtx = null;
let ringInterval = null;
let activeOscillators = [];

function getAudioContext() {
  if (typeof window === "undefined") return null;
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  if (!audioCtx || audioCtx.state === "closed") {
    audioCtx = new AudioCtx();
  }
  return audioCtx;
}

export async function unlockAudio() {
  const ctx = getAudioContext();
  if (!ctx) return;
  try {
    if (ctx.state === "suspended") {
      await ctx.resume();
    }
    // Play a gentle 120ms two-tone confirmation chime (E5 -> A5)
    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(659.25, now); // E5
    osc.frequency.setValueAtTime(880, now + 0.06); // A5
    gain.gain.setValueAtTime(0.04, now);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.12);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + 0.13);
  } catch (_) {}
}

export function startSynthesizedRingtone() {
  const ctx = getAudioContext();
  if (!ctx) return;
  stopSynthesizedRingtone();

  if (ctx.state === "suspended") {
    ctx.resume().catch(() => {});
  }

  const playBurst = () => {
    try {
      if (ctx.state !== "running") {
        ctx.resume().catch(() => {});
      }
      const now = ctx.currentTime;
      // Dual-tone multi-frequency ringback frequencies (440 Hz + 480 Hz)
      const osc1 = ctx.createOscillator();
      const osc2 = ctx.createOscillator();
      const gain = ctx.createGain();

      osc1.type = "sine";
      osc2.type = "sine";
      osc1.frequency.setValueAtTime(440, now);
      osc2.frequency.setValueAtTime(480, now);

      // Volume envelope: smooth fade in, sustain, smooth fade out (total 1.8s)
      gain.gain.setValueAtTime(0.001, now);
      gain.gain.linearRampToValueAtTime(0.18, now + 0.05);
      gain.gain.setValueAtTime(0.18, now + 1.7);
      gain.gain.linearRampToValueAtTime(0.0001, now + 1.8);

      osc1.connect(gain);
      osc2.connect(gain);
      gain.connect(ctx.destination);

      osc1.start(now);
      osc2.start(now);
      osc1.stop(now + 1.85);
      osc2.stop(now + 1.85);

      activeOscillators.push(osc1, osc2);
    } catch (_) {}
  };

  playBurst();
  // Standard phone ring cadence: 1.8s tone + 1.7s pause = 3.5s cycle
  ringInterval = setInterval(playBurst, 3500);
}

export function stopSynthesizedRingtone() {
  if (ringInterval) {
    clearInterval(ringInterval);
    ringInterval = null;
  }
  for (const osc of activeOscillators) {
    try {
      osc.stop();
      osc.disconnect();
    } catch (_) {}
  }
  activeOscillators = [];
}

